var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60999 16.2594L0 16.1494C0.55 16.2194 4.51999 16.0094 4.60999 16.2594Z",
    fill: "#593693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26974 0.0200195L0.00976562 3.14001V16.14C1.54977 16.13 3.08975 16.16 4.61975 16.25V18.77H6.97977L9.52975 16.27C9.52975 16.27 10.9597 16.2401 13.1797 16.1901C14.7497 14.6201 16.3298 13.0501 17.8997 11.4701V0H1.27975L1.26974 0.0200195ZM16.2397 10.77C15.3597 11.67 14.4798 12.5601 13.5998 13.4601L9.06976 13.54L6.46976 16.04V13.52H2.73975V1.67004H16.2397V10.78V10.77Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79037 4.84961H7.36035V9.67957H8.79037V4.84961Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2904 4.84961H11.8604V9.67957H13.2904V4.84961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchIcon);
export default __webpack_public_path__ + "static/media/twitch-icon.6186ba8a819f9d545bbd226bab750002.svg";
export { ForwardRef as ReactComponent };